<svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="fillDefault fillActive" fill-rule="evenodd" clip-rule="evenodd" d="M0.0923063 2.99742L2.09231 0.330753C2.33443 -0.0843097 2.91311 -0.108725 3.19482 0.257506L5.24401 2.99742C5.50327 3.44186 5.18269 4 4.66816 4L0.668159 4C0.153632 4 -0.166949 3.44186 0.0923063 2.99742Z" />
</svg>
